import type { ClientApi } from '../../../../api';
import Helper from '../../../models/Helper';

const URI = '/funding-mechanisms';

/**
 * @desc Helper for funding-mechanisms.
 */
class FundingMechanismsHelper extends Helper {
  constructor(api: ClientApi) {
    super(api, URI);
  }
}

export default FundingMechanismsHelper;
